import axios, { DefaultResponse } from "../general/HttpClient";
import { TypedResponse } from "../general/HttpClient";

export const GetGuides = async (key: string): Promise<TypedResponse<GuideViewModel[]>> => {
    const response = await axios.get<TypedResponse<GuideViewModel[]>>(`/api/guides/GetGuides?key=${key}`);
    return response.data;
};

export const GetGuide = async (id: string): Promise<TypedResponse<GuideViewModel>> => {
    const response = await axios.get<TypedResponse<GuideViewModel>>(`/api/guides/GetGuide/${id}`);
    return response.data;
};

export const CreateGuide = async (request: CreateGuideRequest): Promise<TypedResponse<GuideViewModel>> => {
    const response = await axios.post<TypedResponse<GuideViewModel>>(`/api/guides/CreateGuide`, request);
    return response.data;
};

export const UpdateGuide = async (request: UpdateGuideRequest): Promise<DefaultResponse> => {
    const response = await axios.post<DefaultResponse>(`/api/guides/UpdateGuide`, request);
    return response.data;
};

export const DeleteGuide = async (id: string): Promise<DefaultResponse> => {
    const response = await axios.delete<DefaultResponse>(`/api/guides/DeleteGuide/${id}`);
    return response.data;
};

export interface GuideViewModel {
    id: string;
    name: string;
    guideURI: string;
    thumbnailURI: string;
    key: string;
    organizationID: string;
}

export interface CreateGuideRequest {
    name: string;
    guideURI: string;
    organizationID: string;
    key: string;
}

export interface UpdateGuideRequest {
    id: string;
    name: string;
    guideURI: string;
    thumbnailURI: string;
    key: string;
    organizationID: string;
}
